import { Component, OnInit } from '@angular/core';
import { MainPageService } from '../../main-page.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { BasicDictionaryModel } from '../../../models/dictionaries/basic-dictionary.model';
declare var $: any;

@Component({
  selector: 'app-pipe-fastening-groups-grid',
  template: `<!-- Create Modal -->
<div class="modal" id="addModal">
    <div class="modal-dialog">
        <div class="modal-content">
            <form class="form-group" [formGroup]="formGroup">
                <div class="modal-content">

                    <!-- Modal Header -->
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>

                    <!-- Modal body -->
                    <div class="modal-body display-flex">
                        <div>
                            <div>
                                <div class="display-flex">
                                    <span class="modal-label">Name:</span>
                                    <input type="text" [(ngModel)]="editedPipeFasteningGroup.name" formControlName="name">
                                </div>
                                <div class="display-flex">
                                    <span class="modal-label">Code:</span>
                                    <input type="text" [(ngModel)]="editedPipeFasteningGroup.code" formControlName="code">
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Modal footer -->
                    <div class="modal-footer">
                        <button type="button" class="btn btn-danger red-button" data-dismiss="modal">Cancel</button>
                        <button type="submit" class="btn btn-primary save-button" data-dismiss="modal" [disabled]="formGroup.invalid" (click)="saveNewPipeFasteningGroup()">Save</button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>

<!-- Edit Modal -->
<div class="modal" id="editModal">
    <div class="modal-dialog">
        <div class="modal-content">
            <form class="form-group" [formGroup]="formGroup">
                <div class="modal-content">

                    <!-- Modal Header -->
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>

                    <!-- Modal body -->
                    <div class="modal-body display-flex">
                        <div>
                            <div>
                                <div class="display-flex">
                                    <span class="modal-label">Name:</span>
                                    <input type="text" [(ngModel)]="editedPipeFasteningGroup.name" formControlName="name">
                                </div>
                                <div class="display-flex">
                                    <span class="modal-label">Code:</span>
                                    <input type="text" [(ngModel)]="editedPipeFasteningGroup.code" formControlName="code">
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Modal footer -->
                    <div class="modal-footer">
                        <button type="button" class="btn btn-danger red-button" data-dismiss="modal">Cancel</button>
                        <button type="submit" class="btn btn-primary save-button" data-dismiss="modal" [disabled]="formGroup.invalid" (click)="editPipeFasteningGroup()">Save</button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>

<!-- Delete Modal -->
<div class="modal" id="deleteModal">
    <div class="modal-dialog">
        <div class="modal-content">

            <!-- Modal Header -->
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>

            <!-- Modal body -->
            <div class="modal-body">
                <span class="modal-label">Do you want to delete this Pipe Fastening group?</span>
            </div>

            <!-- Modal footer -->
            <div class="modal-footer">
                <button type="button" class="btn btn-danger" data-dismiss="modal">Cancel</button>
                <button type="submit" class="btn btn-primary" data-dismiss="modal" (click)="deletePipeFasteningGroup(editedPipeFasteningGroup)">Delete</button>
            </div>
        </div>
    </div>
</div>


<div class="input-effect">
    <input class="effect1" type="text" placeholder="">
    <label>Search</label>
    <span class="focus-border"></span>
</div>
<button class="red-button" type="button" data-toggle="modal" data-target="#addModal" (click)="prepareCreate()">Create</button>

<table>
    <tr>
        <th *ngFor="let header of headers">{{header}}</th>
    </tr>
    <tr *ngFor="let pipeFasteningGroup of pipeFasteningGroupsGridData, let row_no = index">
        <td>{{pipeFasteningGroup.name}}</td>
        <td>{{pipeFasteningGroup.code}}</td>
        <td class="columnWithIcons">
            <button type="button" class="btn editBtn" data-toggle="modal" data-target="#editModal" (click)="setChoosenElement(pipeFasteningGroup, row_no)">
                <i class="fa fa-edit"></i>
            </button>
            <button type="button" class="btn deleteBtn" data-toggle="modal" data-target="#deleteModal" (click)="setChoosenElement(pipeFasteningGroup, row_no)">
                <i class="fa fa-trash"></i>
            </button>
        </td>
    </tr>
</table>`,
  styles: [`table{font-family:arial,sans-serif;border-collapse:collapse;width:100%}td,th{border:1px solid #ddd;text-align:left;padding:8px}tr:nth-child(even){background-color:#ddd}.modal-label{width:110px}.display-flex{display:flex;align-items:center;margin-bottom:10px}.search-input{border:none;border-bottom:1px solid gray;outline:0;margin-right:10px}`]
})
export class PipeFasteningGroupsGridComponent implements OnInit {
  isPipeFasteningGroupsHidden = true;
  pipeFasteningGroupsGridData: BasicDictionaryModel[] = [];
  editedPipeFasteningGroup = new BasicDictionaryModel();
  rowNumber: number;
  public formGroup: FormGroup;
  headers: string[] = ['Name', 'Code', ''];

  constructor(private mainPageService: MainPageService) {}

  public ngOnInit(): void {
    this.loadGridDataFromDb();
    this.mainPageService.deletePipeFasteningGroupSubject.subscribe( (value) => {
      this.pipeFasteningGroupsGridData = this.pipeFasteningGroupsGridData.filter(x => x._id !== value);
    });
    this.createForm();
  }

  loadGridDataFromDb() {
    this.mainPageService.loadAllPipeFasteningGroups().subscribe((response) => {
      this.pipeFasteningGroupsGridData = response.sort(function (a, b) {
        return (a.name < b.name) ? -1 : 1;
      });
    });
  }

  toggle() {
    const actionButtons = $('.mat-icon-button');
    $(actionButtons[1]).css('visibility', 'hidden');
    for (let i = 2; i < actionButtons.length; i += 2) {
        $(actionButtons[i]).css('visibility', 'hidden');
    }
    this.isPipeFasteningGroupsHidden = !this.isPipeFasteningGroupsHidden;
  }

  saveNewPipeFasteningGroup() {
    this.mainPageService.addNewPipeFasteningGroupIntoDb(JSON.stringify(this.editedPipeFasteningGroup)).subscribe((response) => {
      this.editedPipeFasteningGroup._id = response._id;
      this.editedPipeFasteningGroup.id = response.id;
      this.pipeFasteningGroupsGridData.push(this.editedPipeFasteningGroup);
      this.editedPipeFasteningGroup = new BasicDictionaryModel();
    });
  }

  setChoosenElement(element, row) {
    this.editedPipeFasteningGroup = {
      ...element,
    };
    this.rowNumber = row;
    this.createForm();
  }

  editPipeFasteningGroup() {
    console.log(this.pipeFasteningGroupsGridData[this.rowNumber]);
    Object.assign(this.pipeFasteningGroupsGridData[this.rowNumber], this.editedPipeFasteningGroup);
    this.mainPageService.updatePipeFasteningGroupInDb(JSON.stringify(this.editedPipeFasteningGroup)).subscribe(() => { });
  }

  deletePipeFasteningGroup(element) {
    this.mainPageService.removePipeFasteningGroup(element._id).subscribe(() => { }, () => { });
    this.mainPageService.deletePipeFasteningGroupSubject.next(element._id);
  }

  public prepareCreate() {
    this.editedPipeFasteningGroup = new BasicDictionaryModel();
    this.createForm();
  }

  private createForm() {
    this.formGroup = new FormGroup({
      name: new FormControl(this.editedPipeFasteningGroup.name, Validators.required),
      code: new FormControl(this.editedPipeFasteningGroup.code),
    });
  }
}
